
import "../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_187_1_Divider";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_187_1_Divider__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-color-border-standard-primary":"--wds-color-border-standard-primary","wds-color-border-dark-primary-active":"--wds-color-border-dark-primary-active","wds-color-border-warning-primary":"--wds-color-border-warning-primary","wds-color-border-destructive-primary":"--wds-color-border-destructive-primary","wds-color-border-success-primary":"--wds-color-border-success-primary","wds-color-border-premium-primary":"--wds-color-border-premium-primary","wds-divider-fill-color-light":"--wds-divider-fill-color-light","wds-divider-vertical-fill-color-light":"--wds-divider-vertical-fill-color-light","wds-border-width-100":"--wds-border-width-100"}; 




